<script>
  import solicitacaoImportacaoServico from '../servico.js';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import Barcode from '@xkeshi/vue-barcode';

  export default {
    components: { Cabecalho, Barcode },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        solicitacaoImportacaoServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          })
          .catch(erro => {
            let msg = erro.message;           
          });

      },
    },
    computed: {

    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação Cancelamento Contrato - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoMostrar = true;
      this.$root.botaoAcaoLink = '';
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-cancelamento-contrato';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              
              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>

              <div v-if="!carregando">
                <cabecalho :titulo="'Solicitação Cancelamento Contrato - Relatório'"></cabecalho>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.idSolicitacaoCancelamentoContrato || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Data da solicitação</dt>
                    <dd>{{ solicitacao.dataSolicitacao | formatarData }} - {{ solicitacao.dataSolicitacao | formatarHora }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Solicitante</dt>
                    <dd>{{ solicitacao.pedidoPor ? solicitacao.pedidoPor.nomePessoaFisicaJuridica : '---'  }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Nome contato</dt>
                    <dd>{{ solicitacao.nomeSolicitante || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Email contato</dt>
                    <dd>{{ solicitacao.emailSolicitante || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Telefone contato</dt>
                    <dd>{{ solicitacao.telefoneSolicitante || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Dados Contrato</h3>
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Nº contrato</dt>
                    <dd>{{ solicitacao.contrato.codigoInterno }}</dd>
                  </dl>

                  <dl class="col-xs-5">
                    <dt>Beneficiário</dt>
                    <dd>{{ solicitacao.contrato.contratada.cpfCnpj || '---' }} - {{ solicitacao.contrato.contratada.nomePessoaFisicaJuridica }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Dados Solicitação</h3>
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Cancelar a partir de</dt>
                    <dd>{{ solicitacao.dataCancelamento }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Motivo cancelamento</dt>
                    <dd>{{ solicitacao.motivoCancelamento || '---' }}</dd>
                  </dl>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-cancelamento-contrato/componentes/SolicitacaoCancelamentoContratoRelatorio.vue